import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  metricSectionContainer: {
    marginBottom: 0,
    paddingBottom: 0,
  },
  metricSectionHeader: {
    marginBottom: 4,
  },
  container: {
    paddingHorizontal: 16,
    paddingTop: 0,
    paddingBottom: 15,
    marginTop: 0,
  },
  description: {
    marginBottom: 14,
    fontSize: 14,
    lineHeight: 18,
    marginLeft: 5,
  },
  buttonContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    justifyContent: 'center',
  },
  createButton: {
    base: {
      flexGrow: 1,
      flexShrink: 1,
      minWidth: '45%',
      padding: 16,
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 4,
      borderRadius: 8,
    },
  },
  shareButton: {
    base: {
      flexGrow: 1,
      flexShrink: 1,
      minWidth: '45%',
      padding: 16,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 8,
      borderWidth: 1,
      borderColor: '#D1D1D1',
      backgroundColor: '#FFF',
      marginRight: 8,
    },
  },
  shareButtonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  shareIcon: {
    fontSize: 20,
    transform: [{translateX: -8}],
  },
  shareButtonLabel: {
    fontSize: 14,
  },
});
